import React, { Suspense  } from 'react';

const ShoppableLookAssignment = React.lazy(() => import('./shoppable_look_assignment'));

export default (props) => (
  <Suspense fallback={ <div>Loading...</div> }>
    <ShoppableLookAssignment { ...props } />
  </Suspense>
);
